import { __extends, __rest } from "tslib";
import React from 'react';
import { FormGroupBase } from './FormGroup';
import { Observer } from 'mobx-react';
import { FormGroupLayoutContext } from '../GridLayout';
import { Components, Utils } from '@singularsystems/neo-core';
var FormGroupInline = /** @class */ (function (_super) {
    __extends(FormGroupInline, _super);
    function FormGroupInline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupInline.prototype.hideLabelForCheckboxes = function () {
        return false;
    };
    FormGroupInline.prototype.getFormGroupClasses = function (domProps, isCheckBox) {
        var classes = _super.prototype.getFormGroupClasses.call(this, domProps, isCheckBox);
        var _a = classes.containerDom, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, xxl = _a.xxl, containerDom = __rest(_a, ["xs", "sm", "md", "lg", "xl", "xxl"]);
        classes.container += " row";
        var colClasses = Components.BootstrapHelpers.getInverseBreakpointClasses(classes.containerDom);
        if (!colClasses.cols) {
            // No sizes were specified, check if there is a layout context
            if (this.contextProps) {
                colClasses = Components.BootstrapHelpers.getInverseBreakpointClasses(this.contextProps);
            }
            if (!colClasses.cols) {
                // If there are still no sizes, default to below.
                classes.label = "col-4";
                classes.editor = "col-8";
            }
        }
        classes.label = Utils.joinWithSpaces(classes.label, "col-form-label", colClasses.cols);
        classes.editor = Utils.joinWithSpaces(classes.editor, colClasses.inverseCols, isCheckBox ? "col-form-label" : undefined);
        classes.containerDom = containerDom;
        return classes;
    };
    FormGroupInline.prototype.render = function () {
        var _this = this;
        return (React.createElement(FormGroupLayoutContext.Consumer, null, function (value) { return (React.createElement(Observer, null, function () { return (_this.contextProps = value.formGroupProps,
            _super.prototype.render.call(_this)); })); }));
    };
    return FormGroupInline;
}(FormGroupBase));
export default FormGroupInline;
